import { gql } from '@apollo/client';

const LargePrizeNotificationsSubscription = gql`
  subscription GetLargePrizeNotifications {
    getLargePrizeNotifications {
      id
    }
  }
`;

export default LargePrizeNotificationsSubscription;
